var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { excludeRoles } from '@/support/ExcludeRoles';
import { StatusColorMap, StatusSelectColorMap } from '@/support/StatusColorMap';
import { Template } from '@/models/Template';
import { UserSubject as UserSubjectModel } from '@/models/UserSubject';
import { RolesEnum } from '@/items/Roles';
import EditSubjectDialog from '@/components/curriculum/EditSubjectDialog';
import UserSubjectSteps from './UserSubjectSteps/UserSubjectSteps';
let UserSubject = class UserSubject extends Vue {
    constructor() {
        // FIXME: Sometimes no user Subject
        super(...arguments);
        this.statusColorMap = StatusColorMap;
        this.statusSelectColorMap = StatusSelectColorMap;
        this.isShowingEditSubjectDialog = false;
        this.templates = [];
        this.subjectTarget = null;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    toggleSelection() {
        this.$emit('update:selected', !this.selected);
    }
    async showSubjectDialog() {
        if (!this.userSubject.tempSubjectId || !this.userSubject.tempStudentId) {
            return;
        }
        await this.fetchUserSubject(this.userSubject.tempSubjectId, this.userSubject.tempStudentId);
        if (['dismissed', 'future'].includes((this.subjectTarget && this.subjectTarget.status) || '')) {
            return;
        }
        if (!this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT])) {
            this.getTemplates(this.userSubject.tempSubjectId);
        }
        this.isShowingEditSubjectDialog = true;
    }
    async fetchUserSubject(subjectId, studentId) {
        try {
            this.subjectTarget = await new UserSubjectModel()
                .user(studentId || '')
                .include(['finished_user', 'available_at_period', 'added_by_user'])
                .filter({ subjects: [subjectId] })
                .first();
        }
        catch (error) {
            //
        }
    }
    async getTemplates(subjectId) {
        try {
            this.templates = await new Template().subject(subjectId).include('file').all();
        }
        catch (error) {
            //
        }
    }
    async onSubjectUpdated(subject) {
        // priorty changed
        if ('has_priority' in subject && this.hasPriority !== !!subject.has_priority) {
            this.$emit('update:hasPriority', subject.has_priority);
            return;
        }
        this.$emit('subjectUpdated');
    }
    onProgressInput(progress) {
        this.userSubject.progress = progress;
        this.$emit('progressUpdated', progress);
    }
    // #endregion
    // #region Async methods (api calls only
    // #endregion
    // #region Getters & Setters
    get isAdminRole() {
        return this.$store.state.Auth.hasRole(['teacher', 'administrator', 'root']);
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    get statusLabel() {
        if (!this.userSubject || !this.userSubject.status) {
            return this.labels.inactive || this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.labels[this.userSubject.status] || this.$tc(`idp.status.${this.userSubject.status}`, 2);
        }
        else {
            return this.labels[label.value] || label.value;
        }
    }
    get statusHighlightColor() {
        return '';
    }
    get showRating() {
        return !!(this.userSubject && this.userSubject.status && this.userSubject.status === 'finished' && this.userSubject.rating && this.userSubject.rating > 0);
    }
    get showProgress() {
        if (!this.userSubject) {
            return false;
        }
        return !!(this.userSubject.progress && this.userSubject.status && this.userSubject.status === 'highlighted');
    }
    get canShowSubjectDialog() {
        return this.userSubject && this.userSubject.status && !['inactive', 'future'].includes(this.userSubject.status);
    }
    get userSubjectStyles() {
        if (!this.userSubject || !this.userSubject.status) {
            return { 'background-color': this.statusColorMap.inactive };
        }
        return { 'background-color': this.statusColorMap[this.userSubject.status] };
    }
    get userSubjectSelectColor() {
        if (!this.userSubject || !this.userSubject.status) {
            return 'white';
        }
        return this.statusSelectColorMap[this.userSubject.status];
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], UserSubject.prototype, "labels", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Boolean)
], UserSubject.prototype, "selected", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Boolean)
], UserSubject.prototype, "hasPriority", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], UserSubject.prototype, "userSubject", void 0);
UserSubject = __decorate([
    Component({
        components: {
            EditSubjectDialog,
            UserSubjectSteps,
        },
    })
], UserSubject);
export default UserSubject;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
